import { Helmet } from 'react-helmet';

/**
 * Injects noindex/nofollow meta robots tag for admin pages.
 * Prevents search engine indexing even if the page is somehow accessible.
 * Used as a defense-in-depth layer alongside robots.txt and auth guards.
 */
export function AdminNoIndex() {
  return (
    <Helmet>
      <meta name="robots" content="noindex, nofollow" />
    </Helmet>
  );
}
